const { render, useState } = wp.element;
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ReactPlayer from "react-player/lazy";

import AudioPlayer from "react-h5-audio-player";

//Import Designs
import { Grid2, CardMedia, Backdrop, CircularProgress } from "@mui/material";
import { encode } from "html-entities";
import { addHours } from "date-fns";
import dateFormat from "dateformat";

class VideoContestant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalopen: null,
            playing: false,
            played: 0,
            duration: 0,
            volume: 8,
        };
    }

    calculateVoteTimeLeft(start_time, pause_voting_hours = 0) {
        let current_date = this.props.currentdate;
        if (!current_date) {
            current_date = new Date();
        }
        if (start_time != null) {
            start_time = start_time.replace(/ /g, "T");
            // var dateFormat = require("dateformat");
            var start_Date = dateFormat(start_time);
            let difference =
                addHours(new Date(start_Date), pause_voting_hours) -
                current_date;
            return difference;
        } else {
            return -1;
        }
    }

    render() {
        const posts =
            typeof this.props.post.posts === "undefined"
                ? this.props.post_single
                : this.props.post.posts;
        let design = this.props.view == "grid" ? "row" : "column";
        const post_index = this.props.indexpost;
        const allprops = this.props;
        let tax_hide_photos = null;
        let vote_start_time = null;
        let vote_end_time = null;
        let hide_photos = 0;
        const get_view = this.props.view;
        let popup_enabled = null;
        let pagin_val_prop = null;
        const shortcode =
            typeof this.props.short !== "undefined"
                ? this.props.short.allcatoption
                : null;
        switch (get_view) {
            case "grid":
                popup_enabled =
                    allprops.settings.common.vote_prettyphoto_disable;
                design = "row";
                break;
            case "list":
                popup_enabled =
                    allprops.settings.common.vote_prettyphoto_disable;
                design = "column";
                break;
            case "single":
                popup_enabled =
                    allprops.settings.common.vote_prettyphoto_disable_single;
                design = "row";
                break;
            case "topten":
                popup_enabled = "on";
                design = "row";
                break;
        }

        const { votes_cont_title_color_grid, votes_cont_title_color } =
            this.props.settings.color;
        let { video_height, music_height } = this.props.settings.style;
        // const { playing, played, duration, volume } = this.state

        const font_colr =
            this.props.view == "grid"
                ? votes_cont_title_color_grid
                : votes_cont_title_color;

        if (typeof allprops.short.allcatoption !== "undefined") {
            tax_hide_photos = allprops.short.allcatoption.tax_hide_photos_live;
            if (allprops?.short?.allcatoption?.votes_starttime) {
                vote_start_time = this.calculateVoteTimeLeft(
                    allprops.short.allcatoption.votes_starttime,
                    allprops.short.allcatoption.pause_voting
                );
            }
            if (allprops?.short?.allcatoption?.votes_expiration) {
                vote_end_time = this.calculateVoteTimeLeft(
                    allprops.short.allcatoption.votes_expiration
                );
            }

            if (tax_hide_photos != "on") {
                hide_photos = "1";
            }
            if (allprops.short.thumb == "0") {
                hide_photos = "0";
            }
            if (vote_start_time < 0) {
                hide_photos = "1";
            }
            if (tax_hide_photos === "on") {
                if (vote_start_time == null && vote_end_time == null)
                    hide_photos = "1";

                if (vote_start_time == null && vote_end_time > 0)
                    hide_photos = "1";

                pagin_val_prop =
                    typeof allprops.post.pagin_val !== "undefined"
                        ? allprops.post.pagin_val
                        : null;

                if (get_view === "single") {
                    pagin_val_prop = allprops.post_single.contestant_count;
                }
                if (pagin_val_prop != null) {
                    let total_posts =
                        get_view === "single"
                            ? pagin_val_prop
                            : pagin_val_prop.total_posts;
                    let tax_activationcount =
                        allprops.short.allcatoption.tax_activationcount;
                    if (
                        tax_activationcount !== null &&
                        tax_activationcount !== 0 &&
                        tax_activationcount !== undefined &&
                        tax_activationcount !== ""
                    ) {
                        if (
                            parseInt(tax_activationcount) <=
                            parseInt(total_posts)
                        ) {
                            hide_photos = "1";
                        } else {
                            hide_photos = "0";
                            if (vote_start_time == null && vote_end_time > 0)
                                hide_photos = "1";
                        }
                        if (vote_start_time == null && vote_end_time == null)
                            hide_photos = "1";
                    }
                }

                if (vote_start_time < 0 && vote_end_time > 0) hide_photos = "1";
            }
        }

        if (shortcode != null) {
            if (
                shortcode.votes_expiration != null &&
                shortcode.votes_expiration != ""
            ) {
                let timer = this.calculateVoteTimeLeft(
                    shortcode.votes_expiration
                );
                if (timer < 0) {
                    hide_photos = "1";
                }
            }
        }

        let contest_type =
            typeof allprops.short.allcatoption !== "undefined"
                ? allprops.short.contest_type
                : null;
        let url_video = null;
        let featured_url = null;
        //override for all contestant shortcode
        if (this.props.all_contest == 1) {
            hide_photos = "1";
            contest_type = this.props.singlepost.img_contest;
            if (video_height == null) {
                video_height = "250";
            }
            if (music_height == null) {
                music_height = "250";
            }
        }
        if (this.props.view == "single") {
            video_height = "";
            music_height = "250";
        }

        let audio_upload =
            typeof allprops.short.allcatoption !== "undefined"
                ? allprops.short.allcatoption.musicfileenable
                : null;
        let term_id =
            typeof this.props.singlepost !== "undefined"
                ? this.props.singlepost.term_id
                : null;

        featured_url =
            this.props.singlepost.page_cont_image != null
                ? this.props.singlepost.page_cont_image
                : this.props.singlepost.featured_image_url;
        if (contest_type != null && contest_type == "video") {
            url_video =
                this.props.singlepost.custom_fields_value[
                    "contestant-ow_video_url"
                ];
            if (typeof url_video === "undefined" || url_video == "") {
                url_video =
                    this.props.singlepost.custom_fields_value[
                        "_ow_video_upload_url"
                    ];
            }
        } else if (contest_type != null && contest_type == "music") {
            if (typeof allprops.taxonomy !== "undefined") {
                let taxonomy = allprops.taxonomy;
                audio_upload = taxonomy.find(
                    (x) => x.term_id === term_id
                ).musicfileenable;
            }
            if (audio_upload != "on") {
                url_video =
                    this.props.singlepost.custom_fields_value[
                        "contestant-ow_music_url_link"
                    ];
                // featured_url = this.props.singlepost.featured_image_url;
                if (typeof url_video === "undefined" || url_video == "") {
                    url_video =
                        this.props.singlepost.custom_fields_value[
                            "contestant-ow_music_url"
                        ];
                }
            } else {
                url_video =
                    this.props.singlepost.custom_fields_value[
                        "contestant-ow_music_url"
                    ];
                // featured_url = this.props.singlepost.featured_image_url;
                if (typeof url_video === "undefined" || url_video == "") {
                    url_video =
                        this.props.singlepost.custom_fields_value[
                            "contestant-ow_music_url_link"
                        ];
                }
            }
        }

        let bitchute_url = "";
        let check_instagram = false;
        let check_bitchute = false;
        let check_tiktok = false;
        let tiktok_video = "";
        let tiktok_width = "100%";
        let tiktok_height = "500";
        if (typeof url_video !== "undefined" && url_video != null) {
            check_instagram = url_video.includes("www.instagram.com");
            check_bitchute = url_video.includes("www.bitchute.com");
            if (check_bitchute) {
                bitchute_url = url_video.replace("video", "embed");
            }

            check_tiktok = url_video.includes("www.tiktok.com");
            if (check_tiktok) {
                const url = new URL(url_video);
                tiktok_video =
                    "https://www.tiktok.com/embed/" +
                    url.pathname.substring(url.pathname.lastIndexOf("/") + 1);
                if (this.props.view == "list") {
                    tiktok_width = "100%";
                    tiktok_height = "750";
                }
                if (this.props.view == "single") {
                    tiktok_width = "100%";
                    tiktok_height = "750";
                }
            }
        }

        const cover = featured_url.includes("img_not_available")
            ? {}
            : { file: { attributes: { poster: featured_url } } };

        if (this.props.singlepost) {
            return (
                <div>
                    {hide_photos != 0 && url_video != null && (
                        <Grid2 className="wpvc_video_audio_div">
                            {audio_upload != "on" && (
                                <CardMedia
                                    className={
                                        "wpvc_card_video_media_" + design
                                    }
                                >
                                    {contest_type == "video" && (
                                        <>
                                            {check_instagram == false &&
                                                check_bitchute == false &&
                                                check_tiktok == false && (
                                                    <ReactPlayer
                                                        url={encode(url_video)}
                                                        playing={false}
                                                        width="100%"
                                                        height={
                                                            contest_type ==
                                                            "video"
                                                                ? video_height +
                                                                  "px"
                                                                : music_height +
                                                                  "px"
                                                        }
                                                        controls={true}
                                                        className={
                                                            contest_type ==
                                                            "music"
                                                                ? "wpvc_music_contest_player"
                                                                : "wpvc_video_contest_player"
                                                        }
                                                        config={{
                                                            youtube: {
                                                                playerVars: {
                                                                    origin: window
                                                                        .location
                                                                        .origin,
                                                                },
                                                            },
                                                            cover,
                                                        }}
                                                    />
                                                )}

                                            {check_instagram == true && (
                                                <div className="wpvc_instagram_parent_div">
                                                    <iframe
                                                        className="wpvc_instagram-media instagram-media-rendered"
                                                        id={
                                                            "instagram-embed-" +
                                                            this.props
                                                                .singlepost.id
                                                        }
                                                        src={
                                                            encode(url_video) +
                                                            "embed/captioned"
                                                        }
                                                        height={video_height}
                                                        frameBorder="0"
                                                        scrolling="no"
                                                        allowtransparency="true"
                                                        allowFullScreen={true}
                                                    ></iframe>
                                                </div>
                                            )}

                                            {check_bitchute == true && (
                                                <iframe
                                                    width="100%"
                                                    className="bitchute_video"
                                                    scrolling="no"
                                                    allowFullScreen={true}
                                                    height={video_height}
                                                    frameBorder="0"
                                                    src={encode(bitchute_url)}
                                                ></iframe>
                                            )}

                                            {check_tiktok == true && (
                                                <div className="wpvc_tiktok_parent_div">
                                                    <iframe
                                                        className="tiktok_video"
                                                        scrolling="no"
                                                        allowFullScreen={true}
                                                        width={tiktok_width}
                                                        height={tiktok_height}
                                                        frameBorder="0"
                                                        src={tiktok_video}
                                                    ></iframe>
                                                </div>
                                            )}
                                        </>
                                    )}

                                    {contest_type == "music" && (
                                        <div className="wpvc_audio_upl_image">
                                            {audio_upload != "on" &&
                                                !encode(url_video)
                                                    .toString()
                                                    .includes("soundcloud") && (
                                                    <CardMedia
                                                        className={
                                                            "wpvc_card_media_audio_upl_" +
                                                            design +
                                                            " wpvc_card_media_" +
                                                            design
                                                        }
                                                        image={
                                                            featured_url != null
                                                                ? featured_url
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            {encode(url_video)
                                                .toString()
                                                .includes("soundcloud") ? (
                                                <ReactPlayer
                                                    url={encode(url_video)}
                                                    playing={false}
                                                    width="100%"
                                                    height={
                                                        contest_type == "video"
                                                            ? video_height +
                                                              "px"
                                                            : music_height +
                                                              "px"
                                                    }
                                                    controls={true}
                                                    className={
                                                        contest_type == "music"
                                                            ? "wpvc_music_contest_player"
                                                            : "wpvc_video_contest_player"
                                                    }
                                                />
                                            ) : (
                                                <AudioPlayer
                                                    src={encode(url_video)}
                                                    customAdditionalControls={[]}
                                                    defaultCurrentTime="Loading"
                                                    defaultDuration="Loading"
                                                    showJumpControls={false}
                                                />
                                            )}
                                        </div>
                                    )}
                                </CardMedia>
                            )}
                            {audio_upload == "on" && (
                                <div className="wpvc_audio_upl_image">
                                    {!encode(url_video)
                                        .toString()
                                        .includes("soundcloud") && (
                                        <CardMedia
                                            className={
                                                "wpvc_card_media_audio_upl_" +
                                                design +
                                                " wpvc_card_media_" +
                                                design
                                            }
                                            image={
                                                featured_url != null
                                                    ? featured_url
                                                    : ""
                                            }
                                        />
                                    )}
                                    {encode(url_video)
                                        .toString()
                                        .includes("soundcloud") ? (
                                        <ReactPlayer
                                            url={encode(url_video)}
                                            playing={false}
                                            width="100%"
                                            height={
                                                contest_type == "video"
                                                    ? video_height + "px"
                                                    : music_height + "px"
                                            }
                                            controls={true}
                                            className={
                                                contest_type == "music"
                                                    ? "wpvc_music_contest_player"
                                                    : "wpvc_video_contest_player"
                                            }
                                        />
                                    ) : (
                                        <AudioPlayer
                                            src={encode(url_video)}
                                            customAdditionalControls={[]}
                                            defaultCurrentTime="Loading"
                                            defaultDuration="Loading"
                                            showJumpControls={false}
                                        />
                                    )}
                                </div>
                            )}
                        </Grid2>
                    )}
                </div>
            );
        } else {
            return (
                <Backdrop className="wpvc_back_loader" open={true}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            );
        }
    }
}

export default connect()(withTranslation("translations")(VideoContestant));
